"use client";

import { useAuth } from "@/context/AuthContext";
import { useRouter, usePathname } from "next/navigation";
import { useEffect } from "react";
import { AuthLoadingScreen } from "@/components/ui/AuthLoadingScreen";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, usuarioRPA, loading } = useAuth();
  const router = useRouter();
  const pathname = usePathname();

  const isPublicRoute =
    pathname === "/login" ||
    pathname === "/blocked" ||
    pathname.startsWith("/upload-docs");

  useEffect(() => {
    if (loading) return;

    if (!user) {
      if (!isPublicRoute) {
        router.push("/login");
      }
    } else if (!usuarioRPA || !usuarioRPA.activo) {
      if (!isPublicRoute) {
        router.push("/blocked");
      }
    } else if (pathname === "/login" || pathname === "/blocked") {
      router.push("/");
    }
  }, [user, usuarioRPA, loading, pathname, router, isPublicRoute]);

  if (loading) {
    return <AuthLoadingScreen />;
  }

  if (!user && isPublicRoute) {
    return <>{children}</>;
  }

  if (!user || !usuarioRPA?.activo) {
    if (isPublicRoute) {
      return <>{children}</>;
    }
    return <AuthLoadingScreen message="Redirigiendo..." />;
  }

  return <>{children}</>;
}
